import React from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { Box, Typography, InputAdornment, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import { HHFormPriceField, HHFormMuiSwitch } from 'components/form-fields/v5'
import { FIELD_WIDTH } from 'components/work-order/disposal-ticket-dialog/disposal-fee/fields/settings'
import { PRICE_FOUR_DECIMAL_SCALE } from 'components/pricing/DisposalFeesV2/create-edit-disposal-fee-dialog/settings'

import T from 'T'

const DisposalFeeRateField = ({ index, unit = '' }) => {
  const { control, watch } = useFormContext()
  const useDisposalFeeRate = watch(`materials.${index}.useDisposalFeeRate`)

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography>{T.RATE}</Typography>
        <Tooltip title={T.RATE_TOOLTIP} arrow placement="top">
          <InfoOutlinedIcon color="action" fontSize="small" />
        </Tooltip>
        <HHFormMuiSwitch name={`materials.${index}.useDisposalFeeRate`} control={control} />
      </Box>
      <HHFormPriceField
        decimalScale={PRICE_FOUR_DECIMAL_SCALE}
        sx={{ width: FIELD_WIDTH }}
        size="small"
        control={control}
        name={`materials.${index}.rate`}
        InputProps={{ endAdornment: <InputAdornment position="end">{`/ ${unit}`}</InputAdornment> }}
        disabled={!useDisposalFeeRate}
      />
    </Box>
  )
}

DisposalFeeRateField.propTypes = {
  index: PropTypes.number,
  unit: PropTypes.string,
}

export default DisposalFeeRateField
